document.addEventListener('DOMContentLoaded',()=>{const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;document.querySelectorAll('[data-os-reveal]').forEach(el=>el.classList.add('bf-os-reveal'));if(!reduce&&'IntersectionObserver'in window){const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target)}}),{rootMargin:'0px 0px -8%'});document.querySelectorAll('.bf-os-reveal').forEach(el=>io.observe(el))}else document.querySelectorAll('.bf-os-reveal').forEach(el=>el.classList.add('is-visible'));const dock=document.querySelector('.bf-os-dock--auto');if(dock){let last=scrollY;addEventListener('scroll',()=>{const now=scrollY;dock.classList.toggle('is-hidden',now>last&&now>180);last=now},{passive:true})}});

/* Media rail: measure once per frame; mobile needs no sticky geometry. */
(() => {
  let frame = 0;
  const update = () => {
    frame = 0;
    const stages = [...document.querySelectorAll('[data-product-media-stage]')];
    if (!stages.length) return;
    if (innerWidth < 1024) { stages.forEach(stage => stage.style.removeProperty('--bf-media-sticky-top')); return; }
    const header = document.querySelector('.bf-header');
    const parent = header?.closest('.bf-header-section');
    const clearance = (parent && getComputedStyle(parent).position === 'sticky' ? header.getBoundingClientRect().height : 0) + 16;
    const values = stages.map(stage => {
      const height = stage.getBoundingClientRect().height;
      return [stage, `${Math.round(height <= innerHeight - clearance - 24 ? clearance : innerHeight - height - 24)}px`];
    });
    values.forEach(([stage, value]) => { if (stage.style.getPropertyValue('--bf-media-sticky-top') !== value) stage.style.setProperty('--bf-media-sticky-top', value); });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  addEventListener('DOMContentLoaded', schedule);
  addEventListener('load', schedule);
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.documentElement);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ticker-toggle]');
    if (!button) return;
    const section = button.closest('.bf-os-proof');
    const paused = section.classList.toggle('is-paused');
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
  });
})();
